/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Logo } from 'components/XTMLogo/Logo';
import { StorageKeyEnum } from 'enums/StorageKeyEnum';
import Help from 'icons/Help';
import Logout from 'icons/Logout';
import ReleaseNotes from 'icons/ReleaseNotes';
import { PureComponent, ReactNode } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { AppDispatch } from 'store';
import { logoutUser } from 'store/auth/auth.actions';
import { getAllEnvironment } from 'utils/handlers/envHandler';
import { versionDigits } from 'utils/versionDigits';
import { getItem } from 'utils/handlers/storageHandler';
import HeaderStyle, { HeaderButton, HeaderContainer, HeaderLogoContainer, HeaderLogoutButton } from './Header.style';

interface IProps {
  children?: ReactNode;
}

interface IDispatchProps {
  logout: () => AppDispatch;
}

type PropType = IProps & WithTranslation & IDispatchProps;

class Header extends PureComponent<PropType> {
  handleOpenLink = (url: string) => (): void => {
    window.open(url, '_blank');
  };

  handleLogout = (): void => {
    this.props.logout();
  };

  render(): JSX.Element {
    const { t } = this.props;
    const { REACT_APP_HELP_URL, REACT_APP_CHANGELOG_URL } = getAllEnvironment();

    return (
      <HeaderContainer position="relative">
        <HeaderLogoContainer>
          <Logo />
          <span css={HeaderStyle.title}>
            {t('common.title')} {t('common.version', { version: versionDigits(process.env.REACT_APP_VERSION),})}
          </span>
        </HeaderLogoContainer>
        <div>
          {getItem(StorageKeyEnum.tokenStorageKey) && REACT_APP_CHANGELOG_URL && (
            <HeaderButton
              disableTouchRipple
              onClick={this.handleOpenLink(REACT_APP_CHANGELOG_URL)}
            >
              <ReleaseNotes />
              {t('common.releaseNotes')}
            </HeaderButton>
          )}
          {getItem(StorageKeyEnum.tokenStorageKey) && REACT_APP_HELP_URL && (
            <HeaderButton disableTouchRipple onClick={this.handleOpenLink(REACT_APP_HELP_URL)}>
              <Help />
              {t('common.help')}
            </HeaderButton>
          )}
          {getItem(StorageKeyEnum.tokenStorageKey) && (
            <HeaderLogoutButton disableTouchRipple onClick={this.handleLogout}>
              <Logout />
              {t('common.logout')}
            </HeaderLogoutButton>
          )}
        </div>
        {this.props.children}
      </HeaderContainer>
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch<AppDispatch>): IDispatchProps => ({
  logout: (): AppDispatch => dispatch(logoutUser()),
});

export default connect(null, mapDispatchToProps)(withTranslation()(Header));
